import React from 'react';
import { CDXUpload } from './cdx-upload';
import { CDXChat } from './cdx-chat';
import './cdx-style.css';

export const CDXChatDocs: React.FC = () => {
  return (
    <div className="cdx-container">
      <header className="cdx-header">
        <h1 className="cdx-title">Chat com Documentos</h1>
        <p className="cdx-subtitle">
          Faça perguntas e obtenha respostas com base nos seus arquivos. 
          Sem arquivos, o chat funciona normalmente.
        </p>
      </header>
      
      <section aria-label="Área de upload de arquivos">
        <CDXUpload />
      </section>
      
      <section aria-label="Área de chat">
        <CDXChat />
      </section>
    </div>
  );
};
